<template>
    <div id="new_driver_commission_policy" class="ui segment">
        <h1 class="ui header">
            <!-- 收派件提成政策 -->
            {{ $t('ui.page_titles.new_driver_commission_policy')}}
        </h1>
        <div v-if="is_initialized">
            <form class="ui form">
                <div class="field">
                    <div class="ui slider checkbox">
                        <input type="checkbox" id="is_activated"
                            v-model="driver_commission_policy.is_activated"
                        >
                        <label class="pointer" for="is_activated">
                            {{ $t('ui.pages.driver_commission_policies.activated')}}
                        </label>
                    </div>
                </div>
                <h3 class="ui header">
                    <!-- 一般件 -->
                    {{ $t('ui.pages.driver_commission_policies.pickup') }}
                </h3>
                <div class="field">
                    <!-- 取件首重重量(KG) -->
                    <label>{{ $t('models.attributes.driver_commission_policies.pick_up_first_weight')}} </label>
                    <input type="number" v-model="driver_commission_policy.pick_up_first_weight">
                </div>
                <div class="field">
                    <!-- 取件首重提成金額 -->
                    <label>{{ $t('models.attributes.driver_commission_policies.pick_up_first_price') }}</label>
                    <input type="number" v-model="driver_commission_policy.pick_up_first_price">
                </div>
                <div class="field">
                    <!-- 取件續重重量單位(KG) -->
                    <label>{{ $t('models.attributes.driver_commission_policies.pick_up_follow_up_weight')}} </label>
                    <input type="number" v-model="driver_commission_policy.pick_up_follow_up_weight">
                </div>
                <div class="field">
                    <!-- 取件續重單價 -->
                    <label>{{ $t('models.attributes.driver_commission_policies.pick_up_follow_up_price') }}</label>
                    <input type="number" v-model="driver_commission_policy.pick_up_follow_up_price">
                </div>
                <div class="field">
                    <!-- 送件首重重量(KG) -->
                    <label>{{ $t('models.attributes.driver_commission_policies.delivery_first_weight')}} </label>
                    <input type="number" v-model="driver_commission_policy.delivery_first_weight">
                </div>
                <div class="field">
                    <!-- 送件首重提成金額 -->
                    <label>{{ $t('models.attributes.driver_commission_policies.delivery_first_price') }}</label>
                    <input type="number" v-model="driver_commission_policy.delivery_first_price">
                </div>
                <div class="field">
                    <!-- 送件續重重量單位(KG) -->
                    <label>{{ $t('models.attributes.driver_commission_policies.delivery_follow_up_weight') }}</label>
                    <input type="number" v-model="driver_commission_policy.delivery_follow_up_weight">
                </div>
                <div class="field">
                    <!-- 送件續重單價 -->
                    <label>{{ $t('models.attributes.driver_commission_policies.delivery_follow_up_price') }}</label>
                    <input type="number" v-model="driver_commission_policy.delivery_follow_up_price">
                </div>

                <div class="ui divider"></div>
                <h3 class="ui header">
                    <!-- 袋裝 -->
                    {{ $t('ui.pages.driver_commission_policies.bag') }}
                </h3>
                <div class="field">
                    <!-- 取件首重重量(KG) -->
                    <label>{{ $t('models.attributes.driver_commission_policies.house_pick_up_first_weight')}} </label>
                    <input type="number" v-model="driver_commission_policy.house_pick_up_first_weight">
                </div>
                <div class="field">
                    <!-- 取件首重提成金額 -->
                    <label>{{ $t('models.attributes.driver_commission_policies.house_pick_up_first_price') }}</label>
                    <input type="number" v-model="driver_commission_policy.house_pick_up_first_price">
                </div>
                <div class="field">
                    <!-- 取件續重重量單位(KG) -->
                    <label>{{ $t('models.attributes.driver_commission_policies.house_pick_up_follow_up_weight')}} </label>
                    <input type="number" v-model="driver_commission_policy.house_pick_up_follow_up_weight">
                </div>
                <div class="field">
                    <!-- 取件續重單價 -->
                    <label>{{ $t('models.attributes.driver_commission_policies.house_pick_up_follow_up_price') }}</label>
                    <input type="number" v-model="driver_commission_policy.house_pick_up_follow_up_price">
                </div>
                <div class="field">
                    <!-- 送件首重重量(KG) -->
                    <label>{{ $t('models.attributes.driver_commission_policies.house_delivery_first_weight')}} </label>
                    <input type="number" v-model="driver_commission_policy.house_delivery_first_weight">
                </div>
                <div class="field">
                    <!-- 送件首重提成金額 -->
                    <label>{{ $t('models.attributes.driver_commission_policies.house_delivery_first_price') }}</label>
                    <input type="number" v-model="driver_commission_policy.house_delivery_first_price">
                </div>
                <div class="field">
                    <!-- 送件續重重量單位(KG) -->
                    <label>{{ $t('models.attributes.driver_commission_policies.house_delivery_follow_up_weight')}} </label>
                    <input type="number" v-model="driver_commission_policy.house_delivery_follow_up_weight">
                </div>
                <div class="field">
                    <!-- 送件續重單價 -->
                    <label>{{ $t('models.attributes.driver_commission_policies.house_delivery_follow_up_price') }}</label>
                    <input type="number" v-model="driver_commission_policy.house_delivery_follow_up_price">
                </div>

                <div class="field">
                    <button class="ui basic fluid positive button" @click.prevent="create">{{ $t('ui.general.create') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "NewDriverCommissionPolicy",
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            driver_commission_policy: {},
            errors: [],
        }
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "new_driver_commission_policy") {
                this.init()
            }
        },
    },
    computed: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                this.is_processing = false
                this.driver_commission_policy = {
                    pick_up_first_weight: 0,
                    pick_up_first_price: 0,
                    pick_up_follow_up_weight: 0,
                    pick_up_follow_up_price: 0,
                    delivery_first_weight: 0,
                    delivery_first_price: 0,
                    delivery_follow_up_weight: 0,
                    delivery_follow_up_price: 0,
                    house_pick_up_first_weight: 0,
                    house_pick_up_first_price: 0,
                    house_pick_up_follow_up_weight: 0,
                    house_pick_up_follow_up_price: 0,
                    house_delivery_first_weight: 0,
                    house_delivery_first_price: 0,
                    house_delivery_follow_up_weight: 0,
                    house_delivery_follow_up_price: 0,
                    is_activated: false
                }
                this.errors = []
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        create() {
            this.is_processing = true
            this.errors = []
            // Prepare parameters
            var params = this.driver_commission_policy
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_driver_commission_policies_create).parse(
                {},
                ""
            )

            return axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(response => {
                if (response.data.status == "success") {
                    this.is_processing = false
                    // this.$noty.success("建立收派件提成政策成功")
                    this.$noty.success(
                        this.$t('ui.notifications.success.create__name', {
                            name: this.$t('models.driver_commission_policies')
                        })
                    )
                    this.$router.push('/provider/driver_commission_policies')
                } else {
                    // this.$noty.error("建立收派件提成政策失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.create__name', {
                            name: this.$t('models.driver_commission_policies')
                        })
                    )
                    this.is_processing = false
                }
            })
            .catch(error => {
                // this.$noty.error("建立收派件提成政策失敗")
                this.$noty.error(
                    this.$t('ui.notifications.error.create__name', {
                        name: this.$t('models.driver_commission_policies')
                    })
                )
                this.is_processing = false
            })
        },
    },
    components: {
    }
}
</script>

<style scoped>
</style>
